<div class="flex flex-col gap-y-3">
    @if (showStatus()) {
    <div class="flex flex-row items-center gap-x-2 text-brand-studio dark:text-brand-studio">
        <span class="size-2.5 rounded-full bg-brand-studio motion-reduce:animate-none"
            [class.animate-pulse]="!isCompiling()" aria-hidden="true"></span>
        <p class="m-0 text-sm font-medium">{{ isCompiling() ? compilingLabel() : statusLabel() }}</p>
    </div>
    }
    <div #thoughtsScroll aria-live="polite" aria-atomic="false"
        class="rounded-lg border border-border bg-muted/40 dark:bg-white/5 p-4 max-h-80 overflow-y-auto">
        @if (!thoughts() && !isCompiling()) {
        <div class="flex flex-col gap-2" aria-hidden="true">
            <div class="h-3 w-5/6 rounded bg-brand-studio/20 motion-reduce:animate-none animate-pulse"></div>
            <div class="h-3 w-2/3 rounded bg-brand-studio/10 motion-reduce:animate-none animate-pulse"></div>
            <div class="h-3 w-3/4 rounded bg-brand-studio/15 motion-reduce:animate-none animate-pulse"></div>
        </div>
        } @else {
        <div class="text-sm text-muted-foreground whitespace-pre-line" [innerHTML]="renderedThoughts()"></div>
        @if (!isCompiling() && thoughts()) {
        <span class="ml-0.5 inline-block h-4 w-0.5 translate-y-0.5 bg-brand-studio motion-reduce:animate-none animate-pulse"
            aria-hidden="true"></span>
        }
        }
        @if (isCompiling()) {
        <div class="mt-3 flex items-center gap-2 border-t border-border/60 pt-3" aria-live="polite">
            <span
                class="size-3.5 shrink-0 motion-reduce:animate-none animate-spin rounded-full border-2 border-brand-studio/25 border-t-brand-studio"
                aria-hidden="true"></span>
            <p class="m-0 text-xs text-muted-foreground">{{ compilingLabel() }}</p>
        </div>
        }
    </div>
</div>
